/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ExpenseAllowedActionsResponseV2, ExpenseCommonFiltersRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ExpensesControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags expenses-controller-v-2
   * @name GetAllowedActions
   * @request POST:/api/v2/expense/allowed-actions
   */
  getAllowedActions = (data: ExpenseCommonFiltersRequest, params: RequestParams = {}) =>
    this.http.request<ExpenseAllowedActionsResponseV2, any>({
      path: `/v2/expense/allowed-actions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllowedActionsPath = '/v2/expense/allowed-actions'
  static getAllowedActionsMethod = 'POST'
}
